import { Address } from '@ecdlink/ui';

export interface ParsedAddress {
  formattedAddress: string;
  latitude: number;
  longitude: number;
  addressLine1: string; // e.g. "123 Main Street"
  addressLine2?: string; // e.g. "Unit 5" or suburb
  city?: string;
  province?: string; // administrative_area_level_1 (state/province)
  postalCode?: string;
  country?: string;
  addressComponents?: Address[]; // keep raw data if needed
}

const getComponent = (
  components: Address[] | undefined,
  type: string,
  useLongName = false
): string | undefined => {
  const component = components?.find((item) =>
    item.types.some((t) => t === type || t.includes(type))
  );
  return useLongName ? component?.long_name : component?.short_name;
};

export const parseGoogleAddress = (
  components: Address[] | undefined,
  lat: number,
  lng: number
): ParsedAddress => {
  const streetNumber = getComponent(components, 'street_number');
  const route = getComponent(components, 'route', true);
  const sublocality = getComponent(components, 'sublocality', true);
  const locality = getComponent(components, 'locality', true);
  const adminLevel2 = getComponent(
    components,
    'administrative_area_level_2',
    true
  );
  const province = getComponent(
    components,
    'administrative_area_level_1',
    true
  );
  const postalCode = getComponent(components, 'postal_code');
  const country = getComponent(components, 'country', true);

  const addressLine1 =
    [streetNumber, route].filter(Boolean).join(' ').trim() || 'Unknown street';

  const addressLine2 = sublocality || '';

  const city = locality || adminLevel2 || sublocality || '';

  const formattedAddress = [
    addressLine1,
    addressLine2,
    city,
    province,
    postalCode,
  ]
    .filter(Boolean)
    .join(', ');

  return {
    formattedAddress,
    latitude: lat,
    longitude: lng,
    addressLine1,
    addressLine2: addressLine2 || undefined,
    city,
    province: province || undefined,
    postalCode: postalCode || undefined,
    country: country || undefined,
    addressComponents: components,
  };
};
